import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { injectIntl, defineMessages } from 'react-intl';

import * as adminActions from 'modules/admin';

import { ConfigTemplate, AdminPageTitle, AdminPageTemplate } from 'components';
import { CtConfigInitial, CtConfigLDAP } from 'containers';

class CtAdminBasicConf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: 0
    };
  }

  componentDidMount() {
    this.getSystemConfig();
  }

  getSystemConfig = async () => {
    const { AdminActions } = this.props;

    try {
      await AdminActions.getSystemConfigBasic();
    } catch (e) {
      console.log(e);
    }

    this.setState({ loaded: 1 });
  };

  render() {
    if (this.state.loaded === 0) {
      return null;
    }

    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isAuth, configClassOrder, configParamOrder } = this.props;

    let classOrder = [];
    if (configClassOrder && List.isList(configClassOrder)) {
      classOrder = configClassOrder.toJS();
    }

    let paramOrder = {};
    if (configParamOrder && Map.isMap(configParamOrder)) {
      paramOrder = configParamOrder.toJS();
    }

    return (
      <AdminPageTemplate>
        <AdminPageTitle small title={defineMessages(formatMessage({ id: 'AdminMenu_1', defaultMessage: '기본설정' }))}>
          <CtConfigInitial category="basic" />
        </AdminPageTitle>
        <ConfigTemplate category="configBasic" order={classOrder} lists={paramOrder} isAuth={isAuth} />
        <CtConfigLDAP category="basic" />
      </AdminPageTemplate>
    );
  }
}

CtAdminBasicConf.propTypes = {};

const mapStateToProps = state => {
  return {
    configClassOrder: state.admin.getIn(['configBasic', 'classOrder']),
    configParamOrder: state.admin.getIn(['configBasic', 'class']),
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  AdminActions: bindActionCreators(adminActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminBasicConf));



// WEBPACK FOOTER //
// ./src/script/containers/admin/config/CtAdminBasicConf.js